import LightningIcon from "@uui/Lightning01";

import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

const NoRecommendations = () => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon Icon={LightningIcon} />
      <EmptyStateTitle>No recommendations</EmptyStateTitle>
      <EmptyStateSubtext>
        There's nothing left to do here! As you have more meetings, Read will
        generate more recommendations and action items.
      </EmptyStateSubtext>
      <Link to={ROUTES.CALENDAR}>
        <Button variant="gradient">View upcoming meetings</Button>
      </Link>
    </EmptyStateContainer>
  );
};

export default NoRecommendations;
